import turboInit from "../../shared/utils/turbo-init"

turboInit(() => {
  const showMoreFiltersButton = document.querySelector(`.-toggle-filters-btn`)
  if (!showMoreFiltersButton) return

  const toggleFilterPanel = () => {
    const allFiltersEl = document.querySelector(`.-filters`)
    const isCollapsed = allFiltersEl.style.maxHeight === `0px`

    allFiltersEl.style.maxHeight = isCollapsed
      ? `${allFiltersEl.scrollHeight}px`
      : `0px`

    allFiltersEl.style.overflow = isCollapsed ? `visible` : `hidden`

    showMoreFiltersButton.querySelector(`span`).textContent = isCollapsed
      ? `Stäng filter`
      : `Visa fler filter`

    showMoreFiltersButton.classList.toggle(`-active`)
  }

  const checkIfFiltersAreActive = () => {
    const allFiltersEl = document.querySelector(`.-filters`)
    const allFiltersInputs = allFiltersEl.querySelectorAll(`input, select`)

    return Array.prototype.some.call(allFiltersInputs, (input) => {
      if (input.tagName === `SELECT`) {
        return input.value !== ``
      } else {
        return input.checked
      }
    })
  }

  // Initially show filters if class is present.
  showMoreFiltersButton.addEventListener(`click`, toggleFilterPanel)

  if (showMoreFiltersButton.classList.contains(`js--filter-initial-active`)) {
    toggleFilterPanel()
  }

  // Handle so the "reset filters"-button shows if filters are active and hides if not.
  const allFiltersEl = document.querySelector(`.-filters`)

  if (allFiltersEl) {
    allFiltersEl.querySelectorAll(`input, select`).forEach((input) => {
      input.addEventListener(`change`, () => {
        const areFiltersActive = checkIfFiltersAreActive()
        const clearFiltersBtnEl = document.querySelector(`.-clear-filters`)
        allFiltersEl.style.maxHeight = allFiltersEl.scrollHeight + `px`

        if (areFiltersActive) {
          clearFiltersBtnEl.style.opacity = 1
        } else {
          clearFiltersBtnEl.style.opacity = 0
        }
      })
    })
  }
})
